import { getURLDomain } from "../common/utils"
import { getStgDomain } from "../common/runtimeConfig";

export const rootDomain = getStgDomain();

export const RIMS_LOCAL_STG_CONSTANTS = {
  LOGIN_TOKEN: 'LOGIN_TOKEN',
  USER_INFO: 'USER_INFO',
  USER_ID: 'USER_ID',
  USER_NAME: 'USER_NAME',
  MENU_AUTH_LIST: 'MENU_AUTH_LIST',
  DATA_AUTH_LIST: 'DATA_AUTH_LIST',
  SESSION_TIME_OUT: 'SESSION_TIME_OUT',
  DISABLE_BACK_PREVIOUS: 'DISABLE_BACK_PREVIOUS',
  TENANT_ID: 'TENANT_ID',
  TENANT_BRANDING_CACHE: 'TENANT_BRANDING_CACHE',
  AC_MENU_STORE: 'ac-menu-store',
}

export const RIMS_COOKIE_STG_CONSTANTS = {
  LOGIN_TOKEN: 'ACCESS_TOKEN',
  USER_INFO: 'USER_INFO',
  DOMAIN: 'DOMAIN',
  MENU_AUTH_LIST: 'MENU_AUTH_LIST',
  DATA_AUTH_LIST: 'DATA_AUTH_LIST',
  SESSION_TIME_OUT: 'SESSION_TIME_OUT',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  USER_NAME: 'USER_NAME',
  USER_TENANT_ID: 'USER_TENANT_ID',
  USER_ID: 'USER_ID',
  USER_EMAIL: 'USER_EMAIL',
  USER_PRIVILEGES: 'USER_PRIVILEGES',
  AC_TENANT_ID: 'AC_TENANT_ID',
  REFRESHED_BY_OTHER_TAB: "REFRESHED_BY_OTHER_TAB",
  REMIAN_TIME: "REMIAN_TIME",
  SESSION_TIME: 'SESSION_TIME',
  COOKIES_LOCK: 'COOKIES_LOCK',
  SESSION_LOCK: 'SESSION_LOCK',
  LOGIN_DOMAIN: 'LOGIN_DOMAIN'
}

export const RIMS_SESSION_STG_CONSTANTS = {
  MODULE_NAME: 'MODULE_NAME',
  PATH_NAME: 'PATH_NAME',
  CURRENT_TENANT_ID: 'CURRENT_TENANT_ID',
  /** Silo tenant customized domain segment; non-empty means Silo, empty/absent means Bridge. */
  CURRENT_TENANT_CUSTOMIZED_DOMAIN: 'CURRENT_TENANT_CUSTOMIZED_DOMAIN',
  IS_FREYR_TENANT: 'IS_FREYR_TENANT',
  /** Per-tab last AC module home path for tenant-switch restore (AB#297311). */
  LAST_AC_MODULE_PATH: 'LAST_AC_MODULE_PATH',
}

export const REGEXP = {
  accountNo: /^[0-9A-Za-z]{4,10}$/,
  desPhoneNum: /(\d{3})\d*(\d{4})/
}

export {
  ADD_DISTRIBUTION_EMAIL_VALIDATION_REGEXP,
  ADD_USER_EMAIL_VALIDATION_REGEXP,
} from './emailValidationRegexp'

export const RTQ_EVENTS = {
  ADMIN: {
    CLOSE_EXPORT_LIST_MODAL: 'CLOSE_EXPORT_LIST_MODAL',
    CLOSE_STATUS_UPDATE_MODAL: 'CLOSE_STATUS_UPDATE_MODAL',
    CLOSE_UPDATE_STATUS_HISTORY_MODAL: 'CLOSE_UPDATE_STATUS_HISTORY_MODAL',
    CLOSE_AUDIT_MODAL: 'CLOSE_AUDIT_MODAL',
    DOWNLOAD_TEMPLATE_START: 'DOWNLOAD_TEMPLATE_START',
    DOWNLOAD_TEMPLATE_END: 'DOWNLOAD_TEMPLATE_END'
  },
  PAGINATION: {
    CHANGE_VALUE: 'CHANGE_VALUE'
  },
  RTQ: {
    CLOSE_QUESTION_MODAL: 'CLOSE_QUESTION_MODAL',
    CLOSE_RESPONSE_MODAL: 'CLOSE_RESPONSE_MODAL',
    CLOSE_SIDE_SEARCH_DRAWER: 'CLOSE_SIDE_SEARCH_DRAWER'
  },
  COMMON: {
    EXPORT_FILE_START: 'EXPORT_FILE_START',
    EXPORT_FILE_END: 'EXPORT_FILE_END'
  },
  HEADER: {
    TOGGLE_MENU_EXTEND: 'TOGGLE_MENU_EXTEND',
    TOGGLE_MENU_COLLAPSED: 'TOGGLE_MENU_COLLAPSED'
  }
}

export const enum ROLE_TYPE_ENUM {
  SUPER_ADMIN = 'Super Administrator',
  PLATFORM_ADMIN = 'Platform Administrator',
  ADMIN_CENTER_ADMIN = 'Admin Center Administrator'
}

export const enum RESOURCE_TYPE_ENUM {
  MENU = "menu",
  PRIVILEGE = "privilege",
  DATA = "data"
}

export const PRIVILEGE_NAME = {
  QUICK_SITE_RESTRICTION: "quick_sight_restriction",
  COUNTRY_RESTRICTION: "global_data_country_restriction",
  PRODUCT_RESTRICTION: "global_data_product_restriction",
  PROCESS_MANAGEMENT_RESTRICTION: 'process_management_restriction'
}

export const pathAuthMapping = new Map([
  ["/user-access-management/", "operate_uam"],
  ["/user-access-management", "operate_uam"],
  ["/user-access-management/users", "operate_users_management"],
  ["/user-access-management/users/import-user", "operate_users_management"],
  ["/user-access-management/users/add-user", "operate_users_management"],
  ["/user-access-management/users/edit-user", "operate_users_management"],
  ["/user-access-management/users/view-user", "operate_users_management"],
  ["/user-access-management/users/reassign-user", "operate_users_management"],
  ["/user-access-management/roles", "operate_roles_management"],
  ["/user-access-management/roles/import-role", "operate_roles_management"],
  ["/user-access-management/roles/add-role", "operate_roles_management"],
  ["/user-access-management/roles/edit-role", "operate_roles_management"],
  ["/user-access-management/roles/view-role", "operate_roles_management"],
  ["/user-access-management/user-groups", "operate_user_groups_management"],
  ["/user-access-management/user-groups/import-user-group", "operate_user_groups_management"],
  ["/user-access-management/user-groups/add-user-group", "operate_user_groups_management"],
  ["/user-access-management/user-groups/edit-user-group", "operate_user_groups_management"],
  ["/user-access-management/user-groups/view-user-group", "operate_user_groups_management"],
  ["/user-access-management/acl", "operate_access_control_management"],
  ["/user-access-management/acl/import-acl", "operate_access_control_management"],
  ["/user-access-management/acl/add-acl", "operate_access_control_management"],
  ["/user-access-management/acl/edit-acl", "operate_access_control_management"],
  ["/user-access-management/acl/view-acl", "operate_access_control_management"],
  ["/user-access-management/distribution", "operate_distribution_lists_management"],
  ["/user-access-management/distribution/add-distribution", "operate_distribution_lists_management"],
  ["/user-access-management/distribution/edit-distribution", "operate_distribution_lists_management"],
  ["/user-access-management/distribution/view-distribution", "operate_distribution_lists_management"],
  ["/user-access-management/distribution/import-distribution", "operate_distribution_lists_management"],
  ["/user-access-management/clients", "operate_clients_management"],
  ["/user-access-management/clients/add-client", "operate_clients_management"],
  ["/user-access-management/clients/edit-client", "operate_clients_management"],
  ["/user-access-management/clients/view-client", "operate_clients_management"],
  ["/configuration", "operate_cm"],
  ["/configuration/menu-manager", "operate_cm"],
  ["/configuration/menu-manager/domain", "operate_cm"],
  ["/configuration/form-manager", "operate_cm"],
  ["/configuration/grid-manager", "operate_cm"],
  ["/configuration/wizard-manager", "operate_cm"],
  ["/configuration/wizard-manager/domain", "operate_cm"],
  ["/configuration/form-manager/fields", "operate_cm"],
  ["/audit", "view_audit"],
  ["/notifications", "view_notifications"],
  ["/reports", "view_admin_center_reports"],
  ["/reports/overview", "view_admin_center_reports"],
  ["/bpmn", "view_process_manager"],
  ["/bpmn/task-manager", "operate_task_manager"],
  ["/bpmn/template-manager", "operate_template_manager"],
  ["/bpmn/auto-launcher", "operate_template_auto_launcher"],
  ["/event-manager", "operate_event_manager"],
  ["/docs-manager", "operate_docs_manager"],
  ["/uimanager", "view_ui_manager"],
  ["/archivemanager", "view_archive_manager"],
  ["/plan-and-automation", "admin-center-view-plan-and-automation"],
])

export const pathWithSpecialAuth = [
  "/notification/payloads",
  "/notification/tasks",
]

export const pathAuthWhiteList = [
  "/workflow-manager",
  "/knowledge-manager"
]

export const MFA_QR_URL = 'otpauth://totp/RTQ:{email}?secret={secret}&issuer=RTQ'

export const UAM_MENU_LIST = [
  {
    name: "Users",
    link: "/user-access-management/users",
  },
  {
    name: "Clients",
    link: "/user-access-management/clients",
  },
  {
    name: "Roles",
    link: "/user-access-management/roles",
  },
  {
    name: "User Groups",
    link: "/user-access-management/user-groups",
  },
  {
    name: "Access Control",
    link: "/user-access-management/acl",
  },
];

export const COOKIE_SETUP = {
  path: "/",
  domain: getURLDomain(),
  secure: true
}

export const COOKIE_SETUP_LIFECYCLE = {
  path: "/",
  domain: getURLDomain(),
  maxAge: 60
};

export const MAIN_COOKIE_SETUP = {
  path: "/",
  domain: rootDomain
}

export const LANGUAGEMAP: { [key: string]: any } = {
  mui: {
    en: "enUS",
    zhCN: "zhCN",
    jp: "jaJP",
  },
};

export const SYSTEM_DAFAULT_PROPERTY_lIST = ["reTaskId", "reTaskModuleId"]

export const MFAStatus = {
  "0": "Disable MFA",
  "2": "Send MFA via e-mail",
  "1": "Send MFA via Authenticator App",
} as const;

export const enum AUTH_MECHANISM_TYPE {
  CUSTOMER_SSO = "customer sso",
  LOGIN_PASSWORD= "login password"
}

export const enum AUTH_MECHANISM_DISPLAY {
  CUSTOMER_SSO = "Customer SSO",
  LOGIN_PASSWORD= "Login Password"
}

export const USERTENANTIDAPI = [
  "/common-uam/resources/menu/related-resource",
  "/common-uam/resources/specified/related-list",
  "/common-uam/session/user-settings",
  "/common-auth/token-url-validation",
  "/common-uam/system-settings/tenant-settings"
]

export const NEED_REMOVE_PADDING = ["task-manager", "template-manager", "template-auto-launcher"]

export const SUPPORT_BUSINESS_RULE_TYPE = ["select", "radio", "checkbox", "text", "date", "number", "grid", "rich-text", "hyperlink"];

export const SUPPORT_CONDITIONAL_MANDATORY_TYPE = ["select", "radio", "checkbox", "text", "date", "number", "grid", "rich-text", "hyperlink"];

export const SUPPORT_LINK_FIELD_Type = ["select", "radio", "checkbox", "text", "date", "number", "rich-text", "hyperlink"];

export const NOT_SUPPORT_AUTOTAG_TYPE = [
  "grid",
  "rich-text",
  "hyperlink",
  "auto-populate",
  "static-text",
  "separator-line",
];

export const MAX_IDENTIFIER_NAME_LENGTH = 250;

export const MAX_TENANT_LABEL_LENGTH = 100;

export const enum FORM_TYPE {
  STEP = "Step",
  MENU = "Menu",
};

export const optionsDependenceType = [
  { label: "From Grid", value: "grid" },
  { label: "From Form", value: "form" },
];
export const FEATURE_FLAG_KEY = {
  AUDIT_REPORTS_V2: "system_audit_reports_v2",
  ACL_DATA_MANAGEMENT_V1: "system_acl_data_manage_v1",
  TENANT_CLIENT_QUOTA: "tenant_client_quota",
  SYSTEM_UAM_QUOTA_V1: "system_user_quota_v1",
};

export const EXPORT_ROW_LIMIT = 10000;

export const MENU_STATUS_DISABLE = "Disable";

export const ACCESS_CONTROL_PRIVILEGE = {
  EDIT: 'edit_access_control',
  DELETE: 'delete_access_control',
  VIEW: 'view_access_control',
  CREATE: 'create_access_control',
  IMPORT: 'import_access_control',
  EXPORT: 'export_access_control',
} as const;

export const USER_PRIVILEGE = {
  EDIT: 'edit_user',
  DELETE: 'delete_user',
  VIEW: 'view_user',
  CREATE: 'create_user',
  IMPORT: 'import_user',
} as const;

export const USER_GROUP_PRIVILEGE = {
  EDIT: 'edit_user_group',
  DELETE: 'delete_user_group',
  VIEW: 'view_user_group',
  CREATE: 'create_user_group',
  IMPORT: 'import_user_group',
  EXPORT: 'export_user_group',
} as const;

export const ROLE_PRIVILEGE = {
  EDIT: 'edit_role',
  DELETE: 'delete_role',
  VIEW: 'view_role',
  CREATE: 'create_role',
  IMPORT: 'import_role',
  EXPORT: 'export_role',
} as const;

/** Data privileges for Clients (ACL privilege nodes; menu uses operate_clients_management). */
export const CLIENT_PRIVILEGE = {
  VIEW: 'view_client',
  CREATE: 'create_client',
  EDIT: 'edit_client',
  DELETE: 'delete_client',
} as const;

export const CM_PRIVILEGE = {
  // view_cm
  VIEW: 'view_cm',
  // view_create_edit_delete
  VIEW_CREATE_EDIT_DELETE: 'view_create_edit_delete_cm',
  // Import Full Configuration JSON
  VIEW_MENU_FULL_IMPORT_JSON: 'view_menu_full_import_json',
  // Export Full Configuration JSON
  VIEW_MENU_FULL_EXPORT_JSON: 'view_menu_full_export_json',
  // Import Wizard Manager JSON
  VIEW_WIZARD_IMPORT_JSON: 'view_wizard_import_json',
  // Export Wizard Manager JSON
  VIEW_WIZARD_EXPORT_JSON: 'view_wizard_export_json',
  // Import Menu Manager JSON
  VIEW_MENU_IMPORT_JSON: 'view_menu_import_json',
  // Export Menu Manager JSON
  VIEW_MENU_EXPORT_JSON: 'view_menu_export_json',
  // exist
  //VIEW_CM_MENU_IMPORT: 'view_cm_menu_import',
  //VIEW_CM_MENU_EXPORT: 'view_cm_menu_export',
  OPERATE_MANDATORY_FIELD_JSON: 'operate_mandatory_field_json',
  OPERATE_NORMAL_FIELD_JSON: 'operate_normal_field_json',
  OPERATE_CUSTOMIZED_JSON: 'customize_form_json',
} as const;

export const MULTI_TENANT = '-3';

export const DIRECT_ASSOCIATION_SOURCE = 'Direct Association';

export const UAM_STATUS = {
  IN_DRAFT: 0,
  ACTIVE: 1,
}

export const QUICKSIGHT_MODULE = {
  ADMIN_CENTER: 'admincenter',
  PLATFORM: 'platform',
} as const;

export const ERROR_CODE = {
  MENU_STEP_DEPENDENCY_ERROR: 5019,
  FIELD_DEPENDENCY_ERROR: 5014,
} as const;